module.exports = __webpack_public_path__ + "static/media/ZFT.8315ba34.pdf";